"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CsvFormatterStream = void 0;

var stream_1 = require("stream");

var formatter_1 = require("./formatter");

var CsvFormatterStream = /*#__PURE__*/function (_stream_1$Transform) {
  _inherits(CsvFormatterStream, _stream_1$Transform);

  var _super = _createSuper(CsvFormatterStream);

  function CsvFormatterStream(formatterOptions) {
    var _this;

    _classCallCheck(this, CsvFormatterStream);

    _this = _super.call(this, {
      writableObjectMode: formatterOptions.objectMode
    });
    _this.hasWrittenBOM = false;
    _this.formatterOptions = formatterOptions;
    _this.rowFormatter = new formatter_1.RowFormatter(formatterOptions); // if writeBOM is false then set to true
    // if writeBOM is true then set to false by default so it is written out

    _this.hasWrittenBOM = !formatterOptions.writeBOM;
    return _this;
  }

  _createClass(CsvFormatterStream, [{
    key: "transform",
    value: function transform(transformFunction) {
      this.rowFormatter.rowTransform = transformFunction;
      return this;
    }
  }, {
    key: "_transform",
    value: function _transform(row, encoding, cb) {
      var _this2 = this;

      var cbCalled = false;

      try {
        if (!this.hasWrittenBOM) {
          this.push(this.formatterOptions.BOM);
          this.hasWrittenBOM = true;
        }

        this.rowFormatter.format(row, function (err, rows) {
          if (err) {
            cbCalled = true;
            return cb(err);
          }

          if (rows) {
            rows.forEach(function (r) {
              _this2.push(Buffer.from(r, 'utf8'));
            });
          }

          cbCalled = true;
          return cb();
        });
      } catch (e) {
        if (cbCalled) {
          throw e;
        }

        cb(e);
      }
    }
  }, {
    key: "_flush",
    value: function _flush(cb) {
      var _this3 = this;

      this.rowFormatter.finish(function (err, rows) {
        if (err) {
          return cb(err);
        }

        if (rows) {
          rows.forEach(function (r) {
            _this3.push(Buffer.from(r, 'utf8'));
          });
        }

        return cb();
      });
    }
  }]);

  return CsvFormatterStream;
}(stream_1.Transform);

exports.CsvFormatterStream = CsvFormatterStream;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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